/**
 * Settings submenu guided tour — runs on first expand of Settings (sidebar).
 * Targets must be mounted (Settings collapse open).
 */

const COPY = {
  settingsIntro: {
    Admin: {
      title: "Settings",
      content:
        "Account setup lives here—company profile, catalog, users, reports, and integrations. Expand this menu anytime to configure Territory CRM.",
    },
    "Sales Director": {
      title: "Settings",
      content:
        "Manage company profile, products, users, and reports from Settings. A quick tour will walk through each item.",
    },
    Manager: {
      title: "Settings",
      content:
        "Open Settings for reports and exports. Use Reports when you need performance data for coaching and reviews.",
    },
  },
  companyProfile: {
    Admin: {
      title: "Company",
      content:
        "Open Company for the company profile, sales teams, and pay scales. Company profile holds the business name and branding used on proposals.",
    },
    "Sales Director": {
      title: "Company",
      content:
        "Open Company for the company profile. That page holds the business name and branding reps see on proposals.",
    },
  },
  productsServices: {
    Admin: {
      title: "Products & Services",
      content:
        "Define what you sell—products, services, pricing—for consistent quotes and proposals.",
    },
    "Sales Director": {
      title: "Products & Services",
      content:
        "Manage the catalog reps use on proposals. Keep products and pricing up to date.",
    },
  },
  users: {
    Admin: {
      title: "Users",
      content:
        "Invite CRM users, assign roles and territories, and deactivate accounts when someone leaves.",
    },
    "Sales Director": {
      title: "Users",
      content:
        "Add and manage team members, roles, and territory access from here.",
    },
  },
  roles: {
    Admin: {
      title: "Roles & Groups",
      content:
        "Review permission groups and what each role can access in the CRM.",
    },
    "Sales Director": {
      title: "Roles & Groups",
      content:
        "See how roles and groups control access across the application.",
    },
  },
  reports: {
    Admin: {
      title: "Reports",
      content:
        "Export performance and activity data filtered by date and scope—for reviews and planning.",
    },
    "Sales Director": {
      title: "Reports",
      content:
        "Pull reports for territories and reps when you need exports or leadership reviews.",
    },
    Manager: {
      title: "Reports",
      content:
        "Your main settings item—run reports and exports for the dates and scope you need.",
    },
  },
  actionLog: {
    Admin: {
      title: "Action Log",
      content:
        "Audit trail of important changes—who did what and when—for support and accountability.",
    },
    "Sales Director": {
      title: "Action Log",
      content:
        "Review significant system changes and user actions when troubleshooting or auditing.",
    },
  },
  subscription: {
    Admin: {
      title: "Subscriptions",
      content:
        "View billing and subscription status for your organization.",
    },
  },
  integrations: {
    Admin: {
      title: "Integrations",
      content:
        "Connect email, maps, and external tools that power SMS, routing, and automation.",
    },
  },
};

export const SETTINGS_TOUR_STEPS = [
  {
    id: "settings-intro",
    selector: '[data-tour="sidebar-settings"]',
    placement: "right",
    roles: ["Admin", "Sales Director", "Manager"],
    copy: COPY.settingsIntro,
  },
  {
    id: "settings-company-profile",
    selector: '[data-tour="sidebar-company"]',
    placement: "right",
    roles: ["Admin", "Sales Director"],
    copy: COPY.companyProfile,
  },
  {
    id: "settings-products-services",
    selector: '[data-tour="sidebar-products-services"]',
    placement: "right",
    roles: ["Admin", "Sales Director"],
    copy: COPY.productsServices,
  },
  {
    id: "settings-users",
    selector: '[data-tour="sidebar-users"]',
    placement: "right",
    roles: ["Admin", "Sales Director"],
    copy: COPY.users,
  },
  {
    id: "settings-roles",
    selector: '[data-tour="sidebar-roles"]',
    placement: "right",
    roles: ["Admin", "Sales Director"],
    requiresRoleSettingsAccess: true,
    copy: COPY.roles,
  },
  {
    id: "settings-reports",
    selector: '[data-tour="sidebar-reports"]',
    placement: "right",
    roles: ["Admin", "Sales Director", "Manager"],
    copy: COPY.reports,
  },
  {
    id: "settings-action-log",
    selector: '[data-tour="sidebar-action-log"]',
    placement: "right",
    roles: ["Admin", "Sales Director"],
    copy: COPY.actionLog,
  },
  {
    id: "settings-subscription",
    selector: '[data-tour="sidebar-subscription"]',
    placement: "right",
    roles: ["Admin"],
    copy: COPY.subscription,
  },
  {
    id: "settings-integrations",
    selector: '[data-tour="sidebar-integrations"]',
    placement: "right",
    roles: ["Admin"],
    copy: COPY.integrations,
  },
];
